function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Hashids =
/*#__PURE__*/
function () {
  function Hashids() {
    var salt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var alphabet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

    _classCallCheck(this, Hashids);

    var minAlphabetLength = 16;
    var sepDiv = 3.5;
    var guardDiv = 12;
    var errorAlphabetLength = 'error: alphabet must contain at least X unique characters';
    var errorAlphabetSpace = 'error: alphabet cannot contain spaces';
    var uniqueAlphabet = '',
        sepsLength,
        diff;
    /* funcs */

    this.escapeRegExp = function (s) {
      return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    };

    this.parseInt = function (v, radix) {
      return /^(-|\+)?([0-9]+|Infinity)$/.test(v) ? parseInt(v, radix) : NaN;
    };
    /* alphabet vars */


    this.seps = 'cfhistuCFHISTU';
    this.minLength = parseInt(minLength, 10) > 0 ? minLength : 0;
    this.salt = typeof salt === 'string' ? salt : '';

    if (typeof alphabet === 'string') {
      this.alphabet = alphabet;
    }

    for (var i = 0; i !== this.alphabet.length; i++) {
      if (uniqueAlphabet.indexOf(this.alphabet.charAt(i)) === -1) {
        uniqueAlphabet += this.alphabet.charAt(i);
      }
    }

    this.alphabet = uniqueAlphabet;

    if (this.alphabet.length < minAlphabetLength) {
      throw errorAlphabetLength.replace('X', minAlphabetLength);
    }

    if (this.alphabet.search(' ') !== -1) {
      throw errorAlphabetSpace;
    }
    /*
    	`this.seps` should contain only characters present in `this.alphabet`
    	`this.alphabet` should not contains `this.seps`
    */


    for (var _i = 0; _i !== this.seps.length; _i++) {
      var j = this.alphabet.indexOf(this.seps.charAt(_i));

      if (j === -1) {
        this.seps = this.seps.substr(0, _i) + ' ' + this.seps.substr(_i + 1);
      } else {
        this.alphabet = this.alphabet.substr(0, j) + ' ' + this.alphabet.substr(j + 1);
      }
    }

    this.alphabet = this.alphabet.replace(/ /g, '');
    this.seps = this.seps.replace(/ /g, '');
    this.seps = this._shuffle(this.seps, this.salt);

    if (!this.seps.length || this.alphabet.length / this.seps.length > sepDiv) {
      sepsLength = Math.ceil(this.alphabet.length / sepDiv);

      if (sepsLength > this.seps.length) {
        diff = sepsLength - this.seps.length;
        this.seps += this.alphabet.substr(0, diff);
        this.alphabet = this.alphabet.substr(diff);
      }
    }

    this.alphabet = this._shuffle(this.alphabet, this.salt);
    var guardCount = Math.ceil(this.alphabet.length / guardDiv);

    if (this.alphabet.length < 3) {
      this.guards = this.seps.substr(0, guardCount);
      this.seps = this.seps.substr(guardCount);
    } else {
      this.guards = this.alphabet.substr(0, guardCount);
      this.alphabet = this.alphabet.substr(guardCount);
    }
  }

  _createClass(Hashids, [{
    key: "encode",
    value: function encode() {
      for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
        numbers[_key] = arguments[_key];
      }

      var ret = '';

      if (!numbers.length) {
        return ret;
      }

      if (numbers[0] && numbers[0].constructor === Array) {
        numbers = numbers[0];

        if (!numbers.length) {
          return ret;
        }
      }

      for (var i = 0; i !== numbers.length; i++) {
        numbers[i] = this.parseInt(numbers[i], 10);

        if (numbers[i] >= 0) {
          continue;
        } else {
          return ret;
        }
      }

      return this._encode(numbers);
    }
  }, {
    key: "decode",
    value: function decode(id) {
      var ret = [];

      if (!id || !id.length || typeof id !== 'string') {
        return ret;
      }

      return this._decode(id, this.alphabet);
    }
  }, {
    key: "encodeHex",
    value: function encodeHex(hex) {
      hex = hex.toString();

      if (!/^[0-9a-fA-F]+$/.test(hex)) {
        return '';
      }

      var numbers = hex.match(/[\w\W]{1,12}/g);

      for (var i = 0; i !== numbers.length; i++) {
        numbers[i] = parseInt('1' + numbers[i], 16);
      }

      return this.encode.apply(this, numbers);
    }
  }, {
    key: "decodeHex",
    value: function decodeHex(id) {
      var ret = [];
      var numbers = this.decode(id);

      for (var i = 0; i !== numbers.length; i++) {
        ret += numbers[i].toString(16).substr(1);
      }

      return ret;
    }
  }, {
    key: "_encode",
    value: function _encode(numbers) {
      var ret,
          alphabet = this.alphabet,
          numbersIdInt = 0;

      for (var i = 0; i !== numbers.length; i++) {
        numbersIdInt += numbers[i] % (i + 100);
      }

      ret = alphabet.charAt(numbersIdInt % alphabet.length);
      var lottery = ret;

      for (var _i2 = 0; _i2 !== numbers.length; _i2++) {
        var number = numbers[_i2];
        var buffer = lottery + this.salt + alphabet;
        alphabet = this._shuffle(alphabet, buffer.substr(0, alphabet.length));

        var last = this._toAlphabet(number, alphabet);

        ret += last;

        if (_i2 + 1 < numbers.length) {
          number %= last.charCodeAt(0) + _i2;
          var sepsIndex = number % this.seps.length;
          ret += this.seps.charAt(sepsIndex);
        }
      }

      if (ret.length < this.minLength) {
        var guardIndex = (numbersIdInt + ret[0].charCodeAt(0)) % this.guards.length;
        var guard = this.guards[guardIndex];
        ret = guard + ret;

        if (ret.length < this.minLength) {
          guardIndex = (numbersIdInt + ret[2].charCodeAt(0)) % this.guards.length;
          guard = this.guards[guardIndex];
          ret += guard;
        }
      }

      var halfLength = parseInt(alphabet.length / 2, 10);

      while (ret.length < this.minLength) {
        alphabet = this._shuffle(alphabet, alphabet);
        ret = alphabet.substr(halfLength) + ret + alphabet.substr(0, halfLength);
        var excess = ret.length - this.minLength;

        if (excess > 0) {
          ret = ret.substr(excess / 2, this.minLength);
        }
      }

      return ret;
    }
  }, {
    key: "_decode",
    value: function _decode(id, alphabet) {
      var ret = [],
          i = 0,
          r = new RegExp("[".concat(this.escapeRegExp(this.guards), "]"), 'g'),
          idBreakdown = id.replace(r, ' '),
          idArray = idBreakdown.split(' ');

      if (idArray.length === 3 || idArray.length === 2) {
        i = 1;
      }

      idBreakdown = idArray[i];

      if (typeof idBreakdown[0] !== 'undefined') {
        var lottery = idBreakdown[0];
        idBreakdown = idBreakdown.substr(1);
        r = new RegExp("[".concat(this.escapeRegExp(this.seps), "]"), 'g');
        idBreakdown = idBreakdown.replace(r, ' ');
        idArray = idBreakdown.split(' ');

        for (var j = 0; j !== idArray.length; j++) {
          var subId = idArray[j];
          var buffer = lottery + this.salt + alphabet;
          alphabet = this._shuffle(alphabet, buffer.substr(0, alphabet.length));
          ret.push(this._fromAlphabet(subId, alphabet));
        }

        if (this.encode(ret) !== id) {
          ret = [];
        }
      }

      return ret;
    }
  }, {
    key: "_shuffle",
    value: function _shuffle(alphabet, salt) {
      var integer;

      if (!salt.length) {
        return alphabet;
      }

      alphabet = alphabet.split("");

      for (var i = alphabet.length - 1, v = 0, p = 0, j = 0; i > 0; i--, v++) {
        v %= salt.length;
        p += integer = salt.charCodeAt(v);
        j = (integer + v + p) % i;
        var tmp = alphabet[j];
        alphabet[j] = alphabet[i];
        alphabet[i] = tmp;
      }

      alphabet = alphabet.join("");
      return alphabet;
    }
  }, {
    key: "_toAlphabet",
    value: function _toAlphabet(input, alphabet) {
      var id = '';

      do {
        id = alphabet.charAt(input % alphabet.length) + id;
        input = parseInt(input / alphabet.length, 10);
      } while (input);

      return id;
    }
  }, {
    key: "_fromAlphabet",
    value: function _fromAlphabet(input, alphabet) {
      return input.split("").map(function (item) {
        return alphabet.indexOf(item);
      }).reduce(function (carry, item) {
        return carry * alphabet.length + item;
      }, 0);
    }
  }]);

  return Hashids;
}();

const hasher = new Hashids(
    'quickApply',
    8,
    'abcdefghijklmnopqrstuvwxyz1234567890',
);

const getQuickApplyHash = jobId => {
    return hasher.encode(jobId)
};

const decodeQuickApplyHash = hash => {
    return hasher.decode(hash)[0]
};

const getCommonCountryAbbreviation = (country) => {
    if(country === 'United Kingdom')
        return 'UK'

    if(country === 'United States')
        return 'USA'

    if(country === 'United Arab Emirates')
        return 'UAE'

    return country
};

const getFormattedJobLocation = (
    { jobLocation, jobLocationDetails },
    { alwaysIncludeAdminArea, excludeCountry, abbreviateCountry = true } = {}
) => {
    if (!jobLocation) {
        return jobLocationDetails || ''
    }

    const { city, adminArea, country } = jobLocation;
    const abbreviatedCountry = abbreviateCountry
        ? getCommonCountryAbbreviation(country)
        : country;

    const formattedCity = city
        ? `${city}`
        : '';

    const formattedAdminArea = adminArea && (!city || alwaysIncludeAdminArea)
        ? `${adminArea}`
        : '';

    const formattedCountry = country && !excludeCountry
        ? `${abbreviatedCountry}`
        : '';

    return [formattedCity, formattedAdminArea, formattedCountry].filter(Boolean).join(', ')
};

const getFormattedJobLocationList = ({ locations }, formatSettings) =>
    locations.map(location => getFormattedJobLocation(
        { jobLocation: location }, formatSettings,
    )).filter(Boolean);

const getUniqueCountriesList = ({ locations }) => {
    // Use array rather than set or object to maintain ordering
    const countries = [];

    locations.forEach(location => {
        if (location && location.country && !countries.includes(location.country)) {
            countries.push(location.country);
        }
    });

    return countries
};

const getJobLocationsDescriptor = ({ locations, defaultDesc = '' }) => {
    const locationsToUse = locations.filter(Boolean);

    if (locationsToUse.length === 0) {
        return {
            type: 'no locations',
            mainLocationDesc: defaultDesc || '',
            otherLocationsDesc: '',
            formattedSublocationList: [],
        }
    }

    if (locationsToUse.length === 1) {
        const mainLocationDesc = getFormattedJobLocation({ jobLocation: locationsToUse[0] });
        return {
            type: 'one location',
            mainLocationDesc,
            otherLocationsDesc: '',
            // mainLocationDesc is the location itself (not an aggregate), so no sublocations
            formattedSublocationList: [],
        }
    }

    const uniqueCountries = getUniqueCountriesList({ locations: locationsToUse, });

    if (uniqueCountries.length > 1) {
        return {
            type: 'multiple countries',
            mainLocationDesc: 'Multiple locations',
            otherLocationsDesc: '',
            formattedSublocationList: getFormattedJobLocationList(
                { locations: locationsToUse },
            ),
        }
    }

    const citiesAndAdminAreas =
        locationsToUse.filter(location => location.city || location.adminArea);
    const isMultipleSpecificLocations = citiesAndAdminAreas.length > 1;

    return {
        type: 'single country',
        mainLocationDesc: uniqueCountries[0] || '',
        otherLocationsDesc: isMultipleSpecificLocations ? '(multiple locations)' : '',
        formattedSublocationList: getFormattedJobLocationList(
            { locations: locationsToUse },
            { excludeCountry: true },
        ),
    }

};


var job = {
    getQuickApplyHash,
    decodeQuickApplyHash,
    getFormattedJobLocation,
    getFormattedJobLocationList,
    getUniqueCountriesList,
    getJobLocationsDescriptor,
};
var job_1 = job.getQuickApplyHash;
var job_2 = job.decodeQuickApplyHash;
var job_3 = job.getFormattedJobLocation;
var job_4 = job.getFormattedJobLocationList;
var job_5 = job.getUniqueCountriesList;
var job_6 = job.getJobLocationsDescriptor;

var job$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': job,
  __moduleExports: job,
  getQuickApplyHash: job_1,
  decodeQuickApplyHash: job_2,
  getFormattedJobLocation: job_3,
  getFormattedJobLocationList: job_4,
  getUniqueCountriesList: job_5,
  getJobLocationsDescriptor: job_6
});

// TheSpanishInquisition

// Cache the matrix. Note that if you not pass a limit this implementation will use a dynamically calculate one.

var damerauLevenshtein = function(__this, that, limit) {

  var thisLength = __this.length,
      thatLength = that.length,
      matrix = [];

  // If the limit is not defined it will be calculate from this and that args.
  limit = (limit || ((thatLength > thisLength ? thatLength : thisLength)))+1;

  for (var i = 0; i < limit; i++) {
    matrix[i] = [i];
    matrix[i].length = limit;
  }
  for (i = 0; i < limit; i++) {
    matrix[0][i] = i;
  }

  if (Math.abs(thisLength - thatLength) > (limit || 100)){
    return prepare (limit || 100);
  }
  if (thisLength === 0){
    return prepare (thatLength);
  }
  if (thatLength === 0){
    return prepare (thisLength);
  }

  // Calculate matrix.
  var j, this_i, that_j, cost, min, t;
  for (i = 1; i <= thisLength; ++i) {
    this_i = __this[i-1];

    // Step 4
    for (j = 1; j <= thatLength; ++j) {
      // Check the jagged ld total so far
      if (i === j && matrix[i][j] > 4) return prepare (thisLength);

      that_j = that[j-1];
      cost = (this_i === that_j) ? 0 : 1; // Step 5
      // Calculate the minimum (much faster than Math.min(...)).
      min    = matrix[i - 1][j    ] + 1; // Deletion.
      if ((t = matrix[i    ][j - 1] + 1   ) < min) min = t;   // Insertion.
      if ((t = matrix[i - 1][j - 1] + cost) < min) min = t;   // Substitution.

      // Update matrix.
      matrix[i][j] = (i > 1 && j > 1 && this_i === that[j-2] && __this[i-2] === that_j && (t = matrix[i-2][j-2]+cost) < min) ? t : min; // Transposition.
    }
  }

  return prepare (matrix[thisLength][thatLength]);

/**
 *
 */
  function prepare(steps) {
    var length = Math.max(thisLength, thatLength);
    var relative = length === 0
      ? 0
      : (steps / length);
    var similarity = 1 - relative;
    return {
      steps: steps,
      relative: relative,
      similarity: similarity
    };
  }

};

const LEVENSHTEIN_THRESHOLD = 0.8;

const calculateStringSimilarity = (oldString, newString) => {
    return damerauLevenshtein(newString, oldString)
};

const stringsSimilarEnough = (oldString, newString) => {
    return calculateStringSimilarity(oldString, newString).similarity >= LEVENSHTEIN_THRESHOLD
};

var edit = {
    calculateStringSimilarity,
    stringsSimilarEnough,
};
var edit_1 = edit.calculateStringSimilarity;
var edit_2 = edit.stringsSimilarEnough;

var edit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': edit,
  __moduleExports: edit,
  calculateStringSimilarity: edit_1,
  stringsSimilarEnough: edit_2
});

const formatMoney = ({ amount, currencyCode = "GBP", includeCurrencyCode = true, locale, minimumDecimalPlaces = 2 }) => {
    try {
        const defaultLocales = ['en', 'en-GB', 'en-US'];
        const automaticLocales = typeof window === 'undefined'
            ? defaultLocales
            : window.navigator.languages;

        const localeChoices = locale ? [locale] : automaticLocales;
        const supportedLocales = Intl.NumberFormat.supportedLocalesOf(localeChoices);

        if (supportedLocales.length === 0) {
            throw new Error('No supported locales')
        }

        const formatter = new Intl.NumberFormat(
            supportedLocales[0],
            {
                style: "currency",
                currency: currencyCode,
                currencyDisplay: "narrowSymbol",
                minimumFractionDigits: minimumDecimalPlaces,
            }
        );

        const numericalAmount = Number.parseFloat(amount);

        if (Number.isNaN(numericalAmount)) {
            throw new Error(`Invalid amount ${numericalAmount}`)
        }

        const currencyCodeText = includeCurrencyCode ? ` (${currencyCode})` : '';
        const formattedAmount = formatter.format(numericalAmount);

        return `${formattedAmount}${currencyCodeText}`
    } catch (error) {
        console.warn(`Unable to format money due to "${error}", using default formatting`);
    }

    return `${amount.toString()} (${currencyCode})`
};

const formatSalaryRange = ({ lowerBound, upperBound, currencyCode, locale }) => {
    const format = (amount, includeCurrencyCode = false) =>
        formatMoney({
            amount,
            currencyCode,
            includeCurrencyCode,
            locale,
            minimumDecimalPlaces: 0,
        });

    const lowerBoundAsNumber = Number.parseFloat(lowerBound);
    const upperBoundAsNumber = Number.parseFloat(upperBound);
    const isLowerBoundValid = !Number.isNaN(lowerBoundAsNumber);
    const isUpperBoundValid = !Number.isNaN(upperBoundAsNumber);

    if (isLowerBoundValid && isUpperBoundValid) {
        if (lowerBound === upperBound) {
            return format(lowerBoundAsNumber, true)
        }
        return `${format(lowerBoundAsNumber)} - ${format(upperBoundAsNumber)} (${currencyCode})`
    }

    if (isLowerBoundValid) {
        return `Starting from ${format(lowerBoundAsNumber, true)}`
    }

    if (isUpperBoundValid) {
        return `Up to ${format(upperBoundAsNumber, true)}`
    }

    return ""
};

var currency = {
    formatMoney,
    formatSalaryRange
};
var currency_1 = currency.formatMoney;
var currency_2 = currency.formatSalaryRange;

var currency$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': currency,
  __moduleExports: currency,
  formatMoney: currency_1,
  formatSalaryRange: currency_2
});

/**
 * @param {{ application: models.Application, interviewTypeId: number }} 
 * @returns {{ label: string, time: string }}
 */
const getStatusForInterview = ({ application, interviewTypeId }) => {
    /* eslint-disable no-underscore-dangle */
    const relevantInterview =
        application.Interviews &&
        application.Interviews.find((applicationInterview) => {
            return (
                parseInt(applicationInterview.InterviewTypeId, 10) ===
                interviewTypeId
            )
        });
    const relevantTokens =
        application._interviewBookingTokens &&
        application._interviewBookingTokens.filter(
            (token) => parseInt(token.InterviewTypeId, 10) === interviewTypeId,
        );
    
    if (
        relevantInterview &&
        relevantInterview.TimeSlot &&
        relevantInterview.TimeSlot.startsAt
    ) {
        return {
            label: 'Booked',
            time: relevantInterview.TimeSlot.startsAt,
        }
    }
    if (
        relevantInterview &&
        relevantInterview.TimeSlot &&
        relevantInterview.TimeSlot.startsAt === null
    ) {
        return {
            label: 'Added',
            time: null,
        }
    }
    if (relevantTokens && relevantTokens.length > 0) {
        return {
            label: 'Invited',
            time: null,
        }
    }
    return {
        label: '-',
        time: null,
    }
};

var interview = { getStatusForInterview };
var interview_1 = interview.getStatusForInterview;

var interview$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': interview,
  __moduleExports: interview,
  getStatusForInterview: interview_1
});

export { currency$1 as currency, edit$1 as edit, interview$1 as interview, job$1 as job };
